export const chargingStatus = {
  "-1": "Failure",
  0: "Not Charging",
  1: "Charging",
};

export const generatePaginationObj = (page = 1, limit = 10) => {
  const offset = (page - 1) * limit;

  return {
    offset,
    limit,
  };
};

export const readableDateTime = (date, format) => {
  const dt = new Date(date);

  const rDate = dt.getDate() < 10 ? `0${dt.getDate()}` : dt.getDate();
  const month = dt.getMonth() + 1;
  const rMonth = month < 10 ? `0${month}` : month;
  const rYear = dt.getFullYear();

  // 12-hour clock (the AM/PM suffix below needs 01-12, not 00-23)
  const hours12 = dt.getHours() % 12 || 12;
  const rHour = hours12 < 10 ? `0${hours12}` : hours12;
  const rMin = dt.getMinutes() < 10 ? `0${dt.getMinutes()}` : dt.getMinutes();

  switch (format) {
    case "dd/mm/yyyy":
      return `${rDate}/${rMonth}/${rYear}`;
    case "mm/dd/yyyy":
      return `${rMonth}/${rDate}/${rYear}`;
    case "dd/mm/yyyy hh:mm":
      return `${rDate}/${rMonth}/${rYear} ${rHour}:${rMin} ${
        dt.getHours() < 12 ? "AM" : "PM"
      }`;
    default:
      return "";
  }
};

export const ORDER_PAYMENT_MODE = {
  CHARGE_THEN_REFUND: "First Charge Then Refund Remaining",
  CHARGE_AT_END: "Charge only after battery return",
};

// Display colour for each order status (antd Tag status colours)
export const ORDER_STATUS_COLORS = {
  CREATED: "processing",
  "REQUEST ACCEPTED": "processing",
  "RENTED BATTERY": "processing",
  "BATTERY RETURNED": "success",
  "ORDER COMPLETED": "success",
  "PAYMENT COMPLETE": "success",
  "AUTO COMPLETED": "success",
  "ORDER FAILED": "error",
  "TIMED OUT": "warning",
};

// Display colour for each charging status (keys match chargingStatus)
export const CHARGING_STATUS_COLORS = {
  "-1": "error",
  0: "default",
  1: "processing",
};

// Server-side table sorting: antd sort order <-> API sortDir
export const SORT_DIR = { ascend: "ASC", descend: "DESC" };
export const SORT_ORDER = { ASC: "ascend", DESC: "descend" };

/**
 * Next sort for a server-sorted antd Table.
 * Toggles ascending/descending on a column (never back to unsorted).
 */
export const getNextSort = (sorter, currentSort) => {
  const sortBy = sorter && sorter.columnKey;
  let order = sorter && sorter.order;

  if (!order) {
    const sameColumn = currentSort && currentSort.sortBy === sortBy;
    order = sameColumn && currentSort.sortDir === "ASC" ? "descend" : "ascend";
  }

  return { sortBy, sortDir: SORT_DIR[order] };
};

// antd sortOrder for a column, from the current { sortBy, sortDir }
export const getColumnSortOrder = (sort, columnKey) =>
  sort && sort.sortBy === columnKey ? SORT_ORDER[sort.sortDir] || null : null;

// Column props for a column sorted on the server
export const serverSortProps = (sort, columnKey) => ({
  sorter: true,
  sortOrder: getColumnSortOrder(sort, columnKey),
  sortDirections: ["ascend", "descend"],
});

// Shared table pagination: page-size selector, bar at the bottom right
export const TABLE_PAGINATION = {
  position: ["bottomRight"],
  showSizeChanger: true,
  pageSizeOptions: [10, 20, 50, 100],
  showTotal: (total, range) => `${range[0]}–${range[1]} of ${total}`,
};

export const COUPON_TYPES = {
  FLAT_OFF: "Flat Off",
  PERCENTAGE_OFF: "Percentage Off",
};

export const PAYMENT_MODES = {
  "First Charge Then Refund Remaining": "CHARGE_THEN_REFUND: ",
  "Charge only after battery return": "CHARGE_AT_END",
};
